import BreakoutTile from './BreakoutTile';

export default BreakoutTile;
